import React from "react";
import { Plane, ArrowUpRight } from "lucide-react";

const AIRLINES = [
  { id: "air-india", name: "Air India", note: "Full-service flights to Jeddah & Madinah", url: "https://linksredirect.com/?cid=331878&source=linkkit&url=https%3A%2F%2Fwww.airindia.com" },
  { id: "air-india-express", name: "Air India Express", note: "Value fares across India & the Gulf", url: "https://linksredirect.com/?cid=331878&source=linkkit&url=https%3A%2F%2Fwww.airindiaexpress.com%2Fhome" },
];

export const FlightBooking = () => (
  <section className="relative overflow-hidden rounded-3xl border border-[#D4AF37]/40 mb-10 min-h-[340px] sm:min-h-[380px]" data-testid="flight-booking-section">
    <img src="/shop/flight.jpg" alt="Aeroplane flying at sunset" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#021A13]/95 via-[#032B20]/80 to-[#032B20]/20" />
    <div className="relative p-7 sm:p-12 max-w-3xl">
      <p className="text-[11px] font-bold tracking-[0.25em] uppercase text-[#D4AF37] flex items-center gap-2"><Plane className="w-4 h-4" /> Fly for your journey</p>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3">Book Your Flight</h2>
      <p className="text-sm sm:text-base text-[#D7E4DE] mt-3 max-w-lg">Search fares and book directly with trusted airlines.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {AIRLINES.map((a) => (
          <a key={a.id} href={a.url} target="_blank" rel="noopener noreferrer sponsored" data-testid={`flight-btn-${a.id}`}
            className="group flex items-center gap-4 rounded-2xl bg-gradient-to-r from-[#D4AF37] via-[#F3D77A] to-[#B8912A] text-[#0A0A0A] px-6 py-5 shadow-[0_10px_30px_rgba(212,175,55,0.35)] hover:-translate-y-1 transition-transform duration-300">
            <span className="w-14 h-14 rounded-full bg-[#032B20] text-[#F3D77A] grid place-items-center shrink-0"><Plane className="w-7 h-7 group-hover:rotate-12 transition-transform" /></span>
            <span className="flex-1">
              <span className="block font-serif text-xl sm:text-2xl font-bold">{a.name}</span>
              <span className="block text-xs sm:text-sm opacity-80">{a.note}</span>
            </span>
            <ArrowUpRight className="w-6 h-6 shrink-0" />
          </a>
        ))}
      </div>
    </div>
  </section>
);
